$(document).ready(function () {
    $(".tabs-nav li").click(function(e) {
        //toggle child
        $('.tabs-nav li').removeClass('is-active');
        $('.tab-pane').removeClass('is-active');
        $(this).addClass('is-active');
        $( $(this).find('a').attr('href') ).addClass('is-active');;
    });

    // open first tab
    $('.tab').first().addClass('is-active');
});